import React, { useEffect, useRef, useState } from "react";
import { renderUrl } from "../../lib/api";

const W = 1280;
const H = 800;

// Scaled, non-interactive iframe of the latest version; mounts only when scrolled into view.
export const LiveThumb = ({ versionId, name }) => {
  const box = useRef(null);
  const [scale, setScale] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = box.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setScale(e.contentRect.width / W));
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); io.disconnect(); } }, { rootMargin: "200px" });
    ro.observe(el);
    io.observe(el);
    return () => { ro.disconnect(); io.disconnect(); };
  }, []);

  return (
    <div ref={box} className="relative w-full h-full overflow-hidden bg-slate-100" data-testid="live-thumb">
      {!versionId ? (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-sky-100 to-white font-display text-3xl font-bold text-sky-300">
          {(name || "?").charAt(0).toUpperCase()}
        </div>
      ) : (
        <>
          <div className="absolute inset-0 shimmer" />
          {visible && scale > 0 && (
            <iframe title={`${name} preview`} src={renderUrl(versionId)} tabIndex={-1} loading="lazy" scrolling="no" aria-hidden="true"
              sandbox="allow-scripts" className="absolute top-0 left-0 border-0 pointer-events-none bg-white origin-top-left"
              style={{ width: W, height: H, transform: `scale(${scale})` }} />
          )}
        </>
      )}
    </div>
  );
};

export default LiveThumb;
